import React, { useMemo } from 'react';
import styled from 'styled-components';

import Dropdown from '#/components/basic/inputs/Dropdown';
import { BigNumberJs } from '#/lib/BigNumber';
import { useSelector } from '#/reduxState/storeCore';

const DropdownWrap = styled.div<{ $minimalLayout: boolean }>`
  margin-left: auto;
  width: 125px;
  ${({ $minimalLayout }) =>
    $minimalLayout
      ? `
    display: inline-flex;
    padding-left: 4px;
    width: initial;
  `
      : ''}
`;

const AggregationSelection = ({
  defaultTickSize,
  selected,
  maximumTickSize,
  onChange,
  minimalLayout,
}: {
  /** As decimal number */
  defaultTickSize?: string;
  selected: string | undefined;
  maximumTickSize: number;
  onChange: (value: string) => void;
  minimalLayout?: boolean;
}) => {
  const currentMarket = useSelector(state => state.markets.currentMarket);

  const options = useMemo(() => {
    if (!defaultTickSize) {
      return undefined;
    }

    const tickSizes = [
      0.00000001, 0.0000001, 0.000001, 0.00001, 0.0001, 0.001, 0.01, 0.1, 1, 10,
      50, 100,
    ];

    if (!currentMarket.pair) {
      return [];
    }

    const levels = tickSizes
      .map(level =>
        level < Number(defaultTickSize) || level > maximumTickSize
          ? null
          : level
      )
      .filter(level => level !== null)
      .map(level => BigNumberJs(level || 0).toString());
    return levels;
  }, [currentMarket.pair, defaultTickSize, maximumTickSize]);

  const dropdownOptions = useMemo(
    () =>
      options
        ? options.map(tickSize => ({
            label: tickSize,
            value: tickSize,
          }))
        : // Loading...
          undefined,
    [options]
  );

  return (
    <DropdownWrap $minimalLayout={!!minimalLayout}>
      <Dropdown
        selected={selected || 'loading'}
        onChange={onChange}
        options={dropdownOptions || [{ value: 'loading', label: '' }]}
        slim
        noBorder
        noPaddingRight
        alignTextRight
        disabledSearchOnDesktop
      />
    </DropdownWrap>
  );
};

export default AggregationSelection;
